export const defaultWidth = 414;
export const defaultHeight = 846;
export const widthUnit = (num: number) => {
    const leverageSize = (window.innerWidth / defaultWidth) * num
    return window.innerWidth > defaultWidth? num : leverageSize;
}

export const heightUnit = (num: number) => {
    const leverageSize = (window.innerHeight / defaultHeight) * num
    return window.innerHeight > defaultHeight? num : leverageSize;
}

export const padGinUnit = (num: number) => {
    return (window.innerWidth / defaultWidth) * num;
}

export const fontUnit = (num: number) => {
    const leverageSize = (window.innerWidth / defaultWidth) * num
    return window.innerWidth > defaultWidth? num : leverageSize;
}